import React from 'react';
import { Input, Select } from '../../components/Common';
import { getFieldMeta } from '../../utils/modeScheduleUtils';
import DirectScheduleConfig from '../../containers/ModeScheduler/DirectCommandConfig';

const ModeConfigurationForm = ({ configValues, setConfigValues, selectedMode, requiredFields, data, timeRange }) => {
    if (!selectedMode?.config_schema?.properties) {
        return null;
    }

    const properties = Object.fromEntries(Object.entries(selectedMode.config_schema.properties).filter(([key]) => key !== 'mode'));
    const modeMeta = getFieldMeta(selectedMode.name) || {};

    const renderInput = (key, field) => {
        const rawValue = configValues[key];
        const value = typeof rawValue === 'object' ? JSON.stringify(rawValue, null, 2) : rawValue ?? '';
        const isRequired = requiredFields.includes(key);
        const fieldMeta = modeMeta[key] || {};

        const label = (
            <label className="mode-scheduler-modal__config-label">
                {field.title || key}
                {isRequired && <span style={{ color: 'red' }}> *</span>}
            </label>
        );

        const commonProps = {
            className: 'mode-scheduler-modal__input',
            value,
            onChange: e => setConfigValues(prev => ({ ...prev, [key]: e.target.value })),
        };

        const description = fieldMeta.description;

        if (field.enum) {
            return (
                <div key={key} className="mode-scheduler-modal__config-field">
                    {label}
                    <Select {...commonProps} options={field.enum.map(opt => ({ value: opt, label: opt }))} />
                    {description && <small style={{ color: '#6b7280', fontSize: '12px' }}>{description}</small>}
                </div>
            );
        }

        if (field.type === 'array' && field.items?.$ref?.includes('DirectScheduleInterval')) {
            return (
                <DirectScheduleConfig
                    key={key}
                    value={rawValue}
                    onChange={next => setConfigValues(prev => ({ ...prev, [key]: next }))}
                    data={data}
                    timeRange={timeRange}
                />
            );
        }

        return (
            <div key={key} className="mode-scheduler-modal__config-field">
                {label}
                <Input type="number" min={fieldMeta.min} max={fieldMeta.max} step={fieldMeta.step} {...commonProps} />
                {description && <small style={{ color: '#6b7280', fontSize: '12px' }}>{description}</small>}
            </div>
        );
    };

    return (
        <div className="mode-scheduler-modal__form-group">
            <label className="mode-scheduler-modal__label">Configuration:</label>
            <div className="mode-scheduler-modal__config">{Object.entries(properties).map(([key, field]) => renderInput(key, field))}</div>
        </div>
    );
};

export default ModeConfigurationForm;
